<div class="main-content">
    <div class="container-fluid">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header card-header-danger">
                    <h4 class="card-title">Search Bar Reports</h4>
                </div>
                <div class="card-body">
                    <form #form="ngForm" (ngSubmit)="search(form)">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="startdate" [min]="createdate" [max]="today"  [(ngModel)]="form.startdate"
                                        name="startdate" required placeholder="Start Date">
                                    <mat-datepicker-toggle matSuffix [for]="startdate"></mat-datepicker-toggle>
                                    <mat-datepicker #startdate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="enddate"  [min]="createdate" [max]="today" [(ngModel)]="form.enddate" name="enddate"
                                        required placeholder="End Date">
                                    <mat-datepicker-toggle matSuffix [for]="enddate"></mat-datepicker-toggle>
                                    <mat-datepicker #enddate></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Module Name</label>
                                    <ng-select class="form-control" #moduleSelect [items]="clientmodule"
                                        [multiple]="false" bindLabel="name" bindValue="id" name="moduleName"
                                        (change)="onClientModuleSelected($event)" required>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Branch Name</label>
                                    <ng-select class="form-control" #branchSelect [items]="Branches" [multiple]="false"
                                        bindLabel="name" bindValue="id" name="branchName"
                                        (change)="onBranchSelected($event)" required>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <button mat-raised-button type="submit" class="btn primary pull-right"
                            [disabled]="!(form.valid && clientmoduleSelected && branchSelected)">Search</button>
                        <button mat-raised-button type="button" class="btn secondary pull-right"
                            (click)="clear()">Clear</button>
                    </form>


                    <br>
                    <br>
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                    </mat-form-field>

                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <!-- Position Column -->
                        <ng-container matColumnDef="startdate">
                            <th mat-header-cell *matHeaderCellDef>Start Date</th>
                            <td mat-cell *matCellDef="let element"> {{element.StartDate}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="enddate">
                            <th mat-header-cell *matHeaderCellDef>End Date</th>
                            <td mat-cell *matCellDef="let element"> {{element.EndDate | date:'yyyy-MM-dd'}} </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="uploaddate">
                                        <th mat-header-cell *matHeaderCellDef>Upload Date</th>
                                        <td mat-cell *matCellDef="let element"> {{element.uploaddate}} </td>
                                    </ng-container> -->

                        <ng-container matColumnDef="download">
                            <th mat-header-cell *matHeaderCellDef> Download </th>
                            <td mat-cell *matCellDef="let element">

                                <button mat-raised-button (click)="loadDataAndCharts(element)"><i class="material-icons">
                                        download
                                    </i></button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div id="audit" class="hide">
        <table class="table2">
            <tr class="tr2">
                <th class="th2" colspan="6">Audit Info </th>
                <th class="th2" colspan="2">Audit Statistics</th>
                <th class="th2" colspan="2">Signature</th>
    
            </tr>
            <tr class="tr2">
                <td class="td2" colspan="6">
                    <ul>
                        <li>Module Name: {{selectedModuleName}}</li>
                        <li>Branch Name: {{selectedBranchName}}</li>
                        <li>Start Date: {{auditForDownload?.StartDate}}</li>
                        <li>End Date: {{auditForDownload?.EndDate}}</li>
                        <li>Type: {{auditForDownload?.TypeAudit}}</li>
                    </ul>
                </td>
                <td class="td2" colspan="2">
                    <ul>
                        <li>Auditor Name: {{auditerdata?.name}}</li>
                        <li>Auditor Email: {{auditerdata?.email}}</li>
    
                        <li>Score : {{allscorequestions}}/{{totalauditpionts}} : {{toalpercentaudit}}%</li>
                    </ul>
                </td>
    
                <td style="width: 220px;height: 139px;">
                    <img   style="width: 220px;height: 139px;" [src]="auditForDownload?.module.signtureurl">
                </td>
            </tr>
    
        </table>
        <ng-container *ngFor="let item of auditForDownload?.module.categories">
        <tr class="tr2">
            <td  colspan="7" class="td2 CatWidth p-2">
                {{item.name}}
            </td>
            <td class="td2" colspan="1">
        <tr class="tr2">
            <td class="td2 BorderB">Points</td>
        </tr>
        <tr>
            <td class="td2 NoBorder text-center">
                {{item.scorequestions}}
            </td>
    
        </tr>
        </td>
        <td class="td2" colspan="1">
            <tr class="tr2">
                <td  class="td2 BorderB">Total</td>
            </tr>
            <tr class="tr2">
                <td class="td2 NoBorder text-center">
                    {{item.totalpointofcat}}
                </td>
    
            </tr>
        </td>
        <td class="td2" colspan="1">
            <tr class="tr2">
                <td class="td2 BorderB">Percent</td>
            </tr>
            <tr class="tr2">
                <td class="td2 NoBorder text-center">
                    {{item.percentcat}}%  
                       </td>
    
            </tr>
        </td>
        </tr>
    <table class="table2">
        <tr class="tr2">
            <th class="th2 QuesTotal">
                Question
            </th>
            <th class="th2">
                Answer
            </th>
            
            <th class="th2">
                Points
            </th>
            
            <th class="th2">
                Total
            </th>
            <th class="th2"> 
                Percent
            </th>
        </tr>
        <tr class="tr2">
            <th class="th2 QuesTotal">
                Audit Category Total
            </th>
            <th>
                
            </th>
            <th class="th2 text-center">
                {{item.scorequestions}}
    
            </th>
            <th class="th2 text-center">
                {{item.totalpointofcat}}
            </th>
            <th class="th2 text-center">
                {{item.percentcat}}%     
            </th>
        </tr>
        <tr class="tr2" *ngFor="let ques of item.questions">
            <td class="td2">
                {{ques.englishname}}?
                <br/>
               <ng-container *ngIf="ques.answerindex !== 'na'" >Comment & Choices</ng-container> 
                <ul>
                    <li *ngFor="let choice of ques?.englishansweredchoices">
                        {{choice}}
                    </li>
                </ul>
    <div class="imagecontainer">
        <div class="row">
            <div  *ngFor="let image of ques?.images">
                <img class="photo" width="100" height="100" [src]="image.url"/>
            </div>
        </div>
    </div>                  
        <p>{{ques?.comment}} </p>
            </td>
            <td class="td2 text-center">
                {{ques.answerindex}}
            </td>
            <td class="td2 text-center">
                {{ques.score}}
            </td>
            <td class="td2 text-center" >
                {{ques.fullscore}}
            </td>
            <td class="td2 text-center">
                {{ques.questionpercent}}
            </td>
        </tr>
    </table>
    
    </ng-container>
    <ng-container *ngFor="let item of auditForDownload?.module.categories">
        <tr class="tr2">
            <td  colspan="7" class="td2 CatWidth p-2">
                {{item.name}}
            </td>
            <td class="td2" colspan="1">
        <tr class="tr2">
            <td class="td2 BorderB">Points</td>
        </tr>
        <tr>
            <td class="td2 NoBorder text-center">
                {{item.scorequestions}}
            </td>
    
        </tr>
        </td>
        <td class="td2" colspan="1">
            <tr class="tr2">
                <td  class="td2 BorderB">Total</td>
            </tr>
            <tr class="tr2">
                <td class="td2 NoBorder text-center">
                    {{item.totalpointofcat}}
                </td>
    
            </tr>
        </td>
        <td class="td2" colspan="1">
            <tr class="tr2">
                <td class="td2 BorderB">Percent</td>
            </tr>
            <tr class="tr2">
                <td class="td2 NoBorder text-center">
                    {{item.percentcat}}%  
                       </td>
    
            </tr>
        </td>
        </tr>
    <table class="table2">
        <tr class="tr2">
            <th class="th2 QuesTotal">
                Question
            </th>
            <th class="th2">
                Answer
            </th>
            
            <th class="th2">
                Points
            </th>
            
            <th class="th2">
                Total
            </th>
            <th class="th2"> 
                Percent
            </th>
        </tr>
        <tr class="tr2">
            <th class="th2 QuesTotal">
                Audit Category Total
            </th>
            <th>
                
            </th>
            <th class="th2 text-center">
                {{item.scorequestions}}
    
            </th>
            <th class="th2 text-center">
                {{item.totalpointofcat}}
            </th>
            <th class="th2 text-center">
                {{item.percentcat}}%     
            </th>
        </tr>
        <tr class="tr2" *ngFor="let ques of item.questions">
            <td class="td2">
                {{ques.englishname}}?
                <br/>
               <ng-container *ngIf="ques.answerindex !== 'na'" >Comment & Choices</ng-container> 
                <ul>
                    <li *ngFor="let choice of ques?.englishansweredchoices">
                        {{choice}}
                    </li>
                </ul>
    <div class="imagecontainer">
        <div class="row">
            <div  *ngFor="let image of ques?.images">
                <img class="photo" width="100" height="100" [src]="image.url"/>
            </div>
        </div>
    </div>                  
        <p>{{ques?.comment}} </p>
            </td>
            <td class="td2 text-center">
                {{ques.answerindex}}
            </td>
            <td class="td2 text-center">
                {{ques.score}}
            </td>
            <td class="td2 text-center" >
                {{ques.fullscore}}
            </td>
            <td class="td2 text-center">
                {{ques.questionpercent}}
            </td>
        </tr>
    </table>
    
    </ng-container>
    <table class="table2" *ngIf="auditCharts">
       <tr class="tr2 summeryFW  text-center ">
        Summary
    </tr> 
    <tr class="tr2">
        <div class="row text-center mt-5">
            <div  class="col-6">
              <div>
                <p class="chartFW text-black">
                    Audit Total Score
                  </p>
                
                <ngx-gauge [type]="gaugeType"
                    [value]="gaugeValue"
                    [append]="gaugeAppendText"
                    [markers]="markerConfig"
                    [size]="300"
                    [thick]="20"
                    [foregroundColor]="'rgba(60, 146, 186,1)'"
                    >
                </ngx-gauge>
            </div>
            </div>
            <div  class="col-6">
              <p class="chartFW text-black">
                Audit Datailed Score
              </p>
              <div id="chartContainerName_{{0}}">
                <canvas id="vmyChart_{{0}}"></canvas>
              </div>
            </div>
    
          </div>
            
            <div class="row text-center mt-5 mb-5">
       
              <div class="col-3">
                <p class="chartFW text-black">
                  Standard Compilation
                 </p>
                <div  id="chartContainerName_{{0}}"  >
                  <canvas id="sandtardcompilationdoughnutChart_{{0}}"></canvas>
                  </div> 
                
              </div>
              <div class="col-3">
                <p class="chartFW text-black">
                  ACTION PLAN FOR TASKS
                  </p>
                <div  id="chartContainerName_{{0}}" >
                  <canvas id="actionplandoughnutChart_{{0}}"></canvas>
                  </div>
              </div>
              <div class="col-6">
                <p class="chartFW text-black">
                  Score Performance Functional Score 
                </p>
                <div id="chartContainerName_{{0}}" style="height:100;" >
                  <canvas id="hmyChart_{{0}}"></canvas>
                  </div>
              </div>
            </div>
    </tr> 
    </table>
    </div>
   

</div>